import { useState } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { FieldValues } from 'react-hook-form';
import { FormTextField } from './FormTextField';

/**
 * Password input with show/hide eye icon. Accepts the same RHF props
 * as FormTextField (name, register, errors).
 */
type Props<T extends FieldValues> = Omit<
  React.ComponentProps<typeof FormTextField<T>>,
  'type' | 'InputProps'
>;

export function PasswordField<T extends FieldValues>(props: Props<T>) {
  const [show, setShow] = useState(false);
  return (
    <FormTextField
      {...props}
      type={show ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShow((s) => !s)}
              edge="end"
              size="small"
              tabIndex={-1}
              aria-label={show ? 'hide password' : 'show password'}
            >
              {show ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
